import { render, staticRenderFns } from "./Template_1.vue?vue&type=template&id=f3e5209c&scoped=true"
import script from "./Template_1.vue?vue&type=script&lang=js"
export * from "./Template_1.vue?vue&type=script&lang=js"
import style0 from "./Template_1.vue?vue&type=style&index=0&id=f3e5209c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e5209c",
  null
  
)

export default component.exports